import Announcements from './Announcements';

export default Announcements;
